<!-- cv简历信息表-头部提示 -->
<template>
  <div class='warn-container'>
    <div class='warn-pic'>
      <img :src='cvWarn' />
    </div>
    <div class='warn-con'>
      <p>Part1-6的内容会直接作为我们填写美国大学申请表格的信息来源。请所有信息都完整准确的填写，一旦出现错误，会直接影响学校的申请。</p>
      <p>Part7-9的内容都没有填写个数的上限，请如实填写</p>
    </div>
  </div>
</template>

<script>
import cvWarn from '@/assets/undergraduate/images/cv_warn.png'
export default {
  name: '',
  components: {},
  data () {
    return {
      // warn图片
      cvWarn
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
img {
  display: block;
  border: none;
}
.warn-container {
  display: flex;
  padding: 20px 70px;
  background: #fff;
  .warn-pic {
    flex: 0 0 64px;
    img {
      width: 64px;
      height: 64px;
    }
  }
  .warn-con {
    flex: 1;
    padding-left: 20px;
    p {
      font-size: 12px;
      color: #667484;
      letter-spacing: 0;
      line-height: 32px;
    }
  }
}
</style>
